import styled, { css } from 'styled-components';

import { Layer, Modal } from '@dreryk/react-components';

import { EmergencyNotificationVariant } from './types';

export const StyledEmergencyNotificationAlertModal = styled(Modal)<{ $variant: EmergencyNotificationVariant }>`
   z-index: ${Layer.FullscreenLoader};

   > * {
      ${({ $variant, theme }) => css`
         border: 2px solid ${$variant === 'error' ? theme.error : theme.borderLight} !important;
         fill: ${$variant === 'error' ? theme.error : theme.background};
         outline: none !important;

         h1 {
            color: ${$variant === 'error' ? theme.error : theme.backgroundDark};
         }
      `}
   }
`;

StyledEmergencyNotificationAlertModal.displayName = 'StyledEmergencyNotificationAlertModal';
